import React, { useRef, useState, useEffect } from "react";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
// import BtnVoirPus from "../../compoment/BtnVoirPus.jsx"
// import { NavLink } from "react-router-dom";
import { FilterMatchMode } from "primereact/api";
// import { InputText } from "primereact/inputtext";
// // import { Button } from "primereact/button";
// import ButtonFeature from "../../features/Button.jsx";
import { LiaCitySolid } from "react-icons/lia";
import "primeicons/primeicons.css";

// import { AiFillDelete } from "react-icons/ai";

import { TabView, TabPanel } from "primereact/tabview";
import instance from "../../api/api.js";

import AllCompomentShared from "../../shared/compoments/AllCompomentShared.jsx";
import { MdOutlineDelete } from "react-icons/md";
import { styleIcone } from "../../shared";
import { MenuPoint, ModalDelete } from "../../shared/compoments";
import { IoMdEye } from "react-icons/io";
// import Swal from "sweetalert2";
// import withReactContent from "sweetalert2-react-content";
// import Spinner from 'react-bootstrap/Spinner';
// import DetailUser from "../DetailUser.jsx";

function VilleListe() {
  // const MySwal = withReactContent(Swal);

  const [cities, setCities] = useState([]);
  // const [citiesId, setCitiesId] = useState("");
  // const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // const action = ({ id }) => {
  //   const deleteCities = () => {
  //     setCitiesId(id);
  //     console.log(citiesId);
  //     setShowModal(true);
  //   };
  //   return (
  //     <div className="d-flex justify-content-center place-items-center gap-3 align-items-center">
  //       <BtnVoirPus
  //       route={`/villes/${id}`}
  //       />
  //      {/* <NavLink to={`/villes/${id}`} style={styleBtn}>
  //       <AiFillEye fontSize="1.5em" /> voir plus
  //     </NavLink> */}
  //     <button
  //       className="btn bg-danger text-light fw-bold"
  //       onClick={deleteCities}
  //     >
  //       <AiFillDelete /> Supprimer
  //     </button>
  //     </div>
  //   );
  // };
  const getListCities = async () => {
    try {
      const response = await instance.get("cities");
      console.log(response.data);
      console.log(response.data.data);
      setCities(response.data.data);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    libelle: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    tarif: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    duree: { value: null, matchMode: FilterMatchMode.EQUALS },
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  useEffect(() => {
    getListCities();
  }, []);

  // const removeCity = async (e) => {
  //   e.preventDefault();
  //   setIsLoading(true);
  //   try {
  //     const response = await instance.delete(`cities/${citiesId}`);
  //     console.log("RESPONSE", response);
  //     if (response.data.status === false) {
  //       MySwal.fire({
  //         title: response.data.message,
  //         icon: "info",
  //         showConfirmButton: true,
  //       });
  //       setIsLoading(false);
  //     } else {
  //       MySwal.fire({
  //         title: response.data.message,
  //         icon: "info",
  //         showConfirmButton: true,
  //       });
  //       setCitiesId("");
  //       setShowModal(false);
  //       setIsLoading(false);
  //       getListCities();
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     MySwal.fire({
  //       title: error.data.message,
  //       icon: "info",
  //       showConfirmButton: true,
  //     });
  //   }
  // };

  return (
    <AllCompomentShared
      libelleHeaderComp={"Liste des villes"}
      titleStatisticHeaderComp={"Nombre de villes"}
      nbreTotalStatistiqueComp={cities.length}
      SearchTableIsSearch={true}
      placeholderInputSearch={"Recherche"}
      globalFilterValue={globalFilterValue}
      onGlobalFilterChange={onGlobalFilterChange}
      iconeStatistiqueHeader={<LiaCitySolid fontSize={"2em"} />}
      isLoading={isLoading}>
      <CitiesDatatable items={cities} filters={filters} />
    </AllCompomentShared>
    // <div className="conteneur-page">
    //   {showModal ? (
    //     <div className="conteneur-modal">
    //       <form onSubmit={removeCity}>
    //         <h5 className="m-2">Voulez-vous supprimer ce coupon ?</h5>
    //         <ButtonFeature
    //           titre="Confirmer"
    //           styleBtn={styleBtn}
    //           isLoading={isLoading}
    //         />
    //         <button
    //           className="btn-lg bg-danger mx-2 border-0 rounded-3 p-2 text-light fw-bold"
    //           onClick={(e) => {
    //             e.preventDefault();
    //             setShowModal(false);
    //           }}
    //         >
    //           Annuler
    //         </button>
    //       </form>
    //     </div>
    //   ) : null}
    //   <h1>Liste des Villes</h1>
    //   {isLoading ? (
    //     <h1 className="text-center mt-5">Chargement....</h1>
    //   ) : (

    //   )}
    // </div>
  );
}
export function CitiesDatatable({ items, filters }) {
  const dt = useRef(null);
  const [open, setOpen] = useState(false);
  const options = [
    {
      name: "Voir plus",
      path: "/villes/",
      icone: <IoMdEye style={styleIcone} />,
      isIdData: true,
    },
    {
      name: "Supprimer",
      icone: <MdOutlineDelete style={styleIcone} />,
      isIdData: true,
      addMethodClick: true,
      methode: (idData) => {
        isDeleteCity(idData);
      },
    },
  ];
  const isDeleteCity = (id) => {
    console.log(id);
    setOpen(true);
  };
  const detailsInfo = (rowData) => {
    return <MenuPoint optionMenu={options} idData={rowData.id} />;
  };
  return (
    <div>
      <ModalDelete
        modalTitle={"Voulez-vous vraiment supprimer cette ville ?"}
        setOpenMethod={setOpen}
        openProp={open}
        dataInfoForBtn={[
          {
            libelleBtn: "Oui",
            color: "error",
            methode: () => {
              console.log("dff");
              // if(isRejectedBtn){
              //   changeStatut('refuse',valueTextField)
              // }
              // if(!isRejectedBtn){
              //   changeStatut('accepter')
              // }
            },
          },
          {
            libelleBtn: "Non",
            isStyle: true,
            methode: () => {
              console.log("dff");
              // dispatch(showModal())
            },
          },
        ]}
      />
      <TabView>
        <TabPanel>
          <DataTable
            ref={dt}
            value={items}
            tableStyle={{ minWidth: "50rem" }}
            paginator
            rows={10}
            filters={filters}
            globalFilterFields={["nom", "contact", "email"]}>
            <Column
              field="name"
              style={{ textAlign: "center" }}
              header="Ville"></Column>
            <Column
              field="id"
              style={{ textAlign: "center" }}
              header="Action"
              body={detailsInfo}></Column>
          </DataTable>
        </TabPanel>
      </TabView>
    </div>
  );
}

export default VilleListe;
